<template>
    <v-chip color="success" text-color="white" v-if="status == 1">Yes</v-chip>
    <v-chip color="red" text-color="white" v-else-if="status == 0">No</v-chip>
    <v-chip v-else>Unknown</v-chip>
</template>

<script>
export default {
    props: {
        status: {
            required: true
        }
    },
    name: "GpsStatus"
}
</script>

<style scoped>

</style>